import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { DestinationAccoLister } from '@/scopes/destinations/components/AccoLister/DestinationAccoLister'
import DestinationInformation from '@/scopes/destinations/components/DestinationInformation/DestinationInformation'
import { Excursions } from '@/scopes/destinations/components/Excursions/Excursions'
import FlightInformation from '@/scopes/destinations/components/FlightInformation'
import LinkedAccommodations from '@/scopes/destinations/components/LinkedAccommodations/LinkedAccommodations'
import OtherRegions from '@/scopes/destinations/components/OtherRegions'
import PracticalInformation from '@/scopes/destinations/components/PracticalInformation'
import Regions from '@/scopes/destinations/components/Regions'
import { SearchButton } from '@/scopes/destinations/components/SearchButton/SearchButton'
import { Video } from '@/scopes/destinations/components/Video'
import WeatherTable from '@/scopes/destinations/components/WeatherTable/WeatherTable'
import { SkiArea } from '../components/SkiArea/SkiArea'
import { Tips } from '../components/Tips/Tips'
import styles from './Destination.module.css'

export default function SunwebContent() {
  const publicationCode = useConfiguration('publicationCode')
  const isWinterSeason = PublicationCodes.isSunwebWinterPublicationCode(publicationCode)

  return (
    <>
      <div className={styles.destinationInfoWrapper}>
        <DestinationInformation />
        <Tips />
      </div>
      <SearchButton />
      <Video />
      <SkiArea />
      <WeatherTable />
      <DestinationAccoLister />
      <Excursions />
      <Regions />
      <OtherRegions />
      <PracticalInformation />
      {!isWinterSeason && <FlightInformation />}
      <SearchButton hiddenOnMobile />
      <LinkedAccommodations />
    </>
  )
}
